export const dev = {
    auth0: {
        domain: 'dev-crew-time.eu.auth0.com',
        clientId: 'QpDM7wQevEUddmZkEo8Li2HNKkSYv9Sb',
        audience: 'https://crew-time/api',
    }
}

export const prod = {
    auth0: {
        domain: 'dev-crew-time.eu.auth0.com',
        clientId: 'QpDM7wQevEUddmZkEo8Li2HNKkSYv9Sb',
        audience: 'https://crew-time/api',
    }
}